class TableGridIconCellController {
  constructor() {
    this.name = 'tableGridIconCell';
  }

  getIcon(row,column){
    return column.map[row[column.name]];
  }
}

export default TableGridIconCellController;



// WEBPACK FOOTER //
// ./app/components/tableGridIconCell/tableGridIconCell.controller.js